import React, { Component } from "react";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Form,Button,Container,Col,Card,InputGroup,FormControl } from 'react-bootstrap';
import { Formik,ErrorMessage } from 'formik';
import * as yup from "yup";

// Same look as the Forgot Password page.
import "../ForgotPasswordRequest/ForgotPasswordRequest.css";

import { resetPassword } from '../../store/actions/userActions';
import { clearRedirect } from '../../store/actions/redirectActions';
import BackButton from "../../components/Template/BackButton";

// Opened from the link in the Forgot Password email: /recover/password/reset/:token?email=...
class ResetPassword extends Component {

  onSubmitHandler = async(values) => {
    await this.props.resetPassword({
      email                 : new URLSearchParams(this.props.location.search).get('email'),
      token                 : this.props.match.params.token,
      new_password          : values.new_password,
      confirm_new_password  : values.confirm_new_password
    })
  }

  render = () => {  

    if( this.props.redirect.run === true && this.props.redirect.link !== null ) {

      this.props.clearRedirect();
      return <Redirect to={this.props.redirect.link} />;
    }

    return (<div id="forgotPasswordRequest">
              <Container className="min-vh-80 d-flex flex-column justify-content-center">
              <Col md={8}>
                  <Card>
                      <Card.Body>
                          <div className="card-text">
                              <Formik validationSchema={validationSchema} onSubmit={this.onSubmitHandler}
                              initialValues={{ new_password: '', confirm_new_password: '' }}>
                              {({ values, handleChange, handleSubmit }) => (
                                  <form onSubmit={handleSubmit}>
                                      <h3>Choose a new password</h3>
                                      <span className="forgot-password-header">
                                        New password (at least 8 characters):
                                      </span>
                                      <InputGroup>
                                        <FormControl class="form-control" type="password" variant="primary" name="new_password" onChange={handleChange} value={values.new_password} />
                                        <Form.Control.Feedback type="invalid">
                                            <ErrorMessage component="div" name={"new_password"} className="input-feedback" />
                                        </Form.Control.Feedback> 
                                      </InputGroup> 
                                      <span className="forgot-password-header">
                                        Confirm new password:
                                      </span>
                                      <InputGroup>
                                        <FormControl class="form-control" type="password" variant="primary" name="confirm_new_password" onChange={handleChange} value={values.confirm_new_password} />
                                        <Form.Control.Feedback type="invalid">
                                            <ErrorMessage component="div" name={"confirm_new_password"} className="input-feedback" />
                                        </Form.Control.Feedback> 
                                      </InputGroup> 
                                      <br/>

                                    <Button type="submit" >
                                      <i className="fa fa-key" />  Reset password
                                    </Button>
                                    &nbsp;
                                    <BackButton  style={{'float': 'right'}} {...this.props} />
                                  </form>
                                  )}
                              </Formik>
                          </div>
                      </Card.Body>
                  </Card>
              </Col>
          </Container>
            </div>
  );
  }
}


// Object for Data Validation
const validationSchema = yup.object().shape({
  new_password: yup
    .string()
    .min(8, '8 Minimum Characters')
    .max(255, '255 Maximum Characters')
    .required("This field is required"),
  confirm_new_password: yup
    .string()
    .max(255, '255 Maximum Characters')
    .required("This field is required")
    .oneOf([yup.ref('new_password')], 'Your passwords do not match.')
});

const mapStateToProps = (state) => {
  return {
    redirect          : state.redirect
  }
}
const mapDispatchToProps = (dispatch) => {
    return {
      resetPassword : ( data ) => dispatch( resetPassword( data ) ),
      clearRedirect : () => dispatch( clearRedirect() )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
